/**
 * Component for the page where the customer selects
 * the Return Method (e.g. shipping label). This page
 * also shows any label- or restocking fees to the customer
 * if these have been enabled by our user.
 * 
 * @component
 */

import { Button,Card,Col,Divider,Radio,Row,Select,message } from "antd"
import axios from "axios"
import React from "react"
import { FormattedMessage } from "react-intl"
import '../../styles/Visitor.css'

const { Option } = Select;

class Method extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      methodInStore: undefined,
      methodLabelCreation: undefined,
      methodLabelManual: undefined,
      methodCustomerChoice: undefined,
      value: undefined,
      dropdownWidth: 400,
      submitButtonDisabled: false,
      submitButtonLoading: false,
      methodCustomerPaidLabel: false,
      convenienceReturn: undefined,
      enableConvenience: false,
      returnPreference: undefined,
      freeReturn: false,
      isLoading: true,
    };
  }

  async componentDidMount() {
    // scroll to top of page
    window.scrollTo(0, 0);
    const { companyIdentifier, returnNumber, returnSettings } = this.props;

    try {
      const response = await axios.post("/api/visitors/return/shipping", {
        companyIdentifier,
        returnNumber
      });
      if (response.data.status === "error") {
        this.setState({
          isLoading: false,
        });
        return message.error("There was an error loading your shipping options. Please try again.", 5);
      }

      const updatedReturn = response.data.returnData;
      const disabledConvenience = response.data.disabledConvenience;

      const enableConvenience = disabledConvenience ? false : returnSettings.enableConvenience;
      const convenienceReturn = returnSettings.templates['convenienceTemplate'];

      this.setState((prevState) => ({
        isLoading: false,
        freeReturn: updatedReturn.freeReturn,
        ...response.data.availableShippingMethods,
        enableConvenience,
        convenienceReturn,
      }));

      updatedReturn.isShippingResolution = this.props.returnData?.isShippingResolution;

      return this.props.updateBrandSettings({
        returnData: updatedReturn,
      });

    } catch(err) {
      this.setState({
        isLoading: false,
      });
      return message.error("There was an error loading your shipping options. Please try again.", 5);
    }
  }

  handleSubmit = async () => {
    const { companyIdentifier, returnNumber } = this.props;
    const selectedMethod = this.state.value;
    const  returnPreference = this.state.returnPreference;

    if (selectedMethod === undefined) {
      return message.error("Please select a method to return your order.", 5);
    }

    try {

      this.setState({
        submitButtonDisabled: true,
        submitButtonLoading: true,
      });

      const response = await axios.post("/api/visitors/return/shipping/update", {
        companyIdentifier,
        returnNumber,
        selectedMethod,
        returnPreference
      });
      if (response.data.status === "error") {
        this.setState({
          submitButtonDisabled: false,
          submitButtonLoading: false,
        });
        return message.error("We are unable to process your return request at this time. Please contact store support.", 4);
      }
      if (response.data.redirectToPayment) {
        return this.props.history.push('/return/payment');
      } else {
        return this.props.history.push('/return/status');
      }
    } catch(err) {
      this.setState({
        submitButtonDisabled: false,
        submitButtonLoading: false,
      });
      return message.error("We are unable to process your return request at this time. Please contact store support.", 4);
    }
  }

  handleChange  = (value) => {
    this.setState({
      value,
    });
  }

  handleReturnReference = (value) => {
    this.setState({
      returnPreference: value,
    });
  }

  render() {
    return(
      <React.Fragment>
        <Card
          title={
            <FormattedMessage
              id="app.visitor.method.headline"
              description="Title of the fourth step of the return-portal process 'shipping method'"
              defaultMessage="How would you like to return your order?"
            />
          }
          className="textCenter"
        >
          <Row type="flex" justify="center" align="top">
            <Col span={24}>
              <Select
                id="selectReturnMethodDropdown"
                value={this.state.value}
                placeholder={
                  <FormattedMessage
                    id="app.visitor.method.titleOfDropdown"
                    description="Shipping method selection dialog: title of the dropdown menu"
                    defaultMessage="Select how to return your order"
                  />
                }
                style={{ width: '100%' }}
                onChange={this.handleChange.bind(this)}
              >
                {
                  this.state.methodLabelCreation
                    ? (<Option value="methodLabelCreation">
                      <FormattedMessage
                        id="app.visitor.method.methodLabelCreation"
                        description="Shipping method selection dialog: pre-paid return label (automatic)"
                        defaultMessage="Ship via pre-paid return label"
                      />
                    </Option>)
                    : ""
                }
                {
                  this.state.methodLabelManual
                    ? (<Option value="methodLabelManual">
                      <FormattedMessage
                        id="app.visitor.method.methodLabelManual"
                        description="Shipping method selection dialog: pre-paid return label (manual)"
                        defaultMessage="Ship via pre-paid return label"
                      />
                    </Option>)
                    : ""
                }
                {
                  this.state.methodCustomerChoice
                    ? (<Radio value="methodCustomerChoice">
                      <FormattedMessage
                        id="app.visitor.method.methodCustomerChoice"
                        description="Shipping method selection dialog: customer chooses carrier"
                        defaultMessage="Ship with the carrier of your choice"
                      />
                    </Radio>)
                    : ""
                }
                {
                  this.state.methodCustomerPaidLabel
                  && (<Radio value="methodCustomerPaidLabel">
                    <FormattedMessage
                      id="app.visitor.method.methodCustomerPaidLabel"
                      description="Shipping method selection dialog: Customer Paid Return Label"
                      defaultMessage="Customer Paid Return Label"
                    />
                  </Radio>)
                }
                {
                  this.state.methodInStore
                    ? (<Radio value="methodInStore">
                      <FormattedMessage
                        id="app.visitor.method.methodInStore"
                        description="Shipping method selection dialog: in store return"
                        defaultMessage="Return in a local store"
                      />
                    </Radio>)
                    : ""
                }
              </Select>
            </Col>
          </Row>
          <Divider />
          {this.state.enableConvenience && ['methodLabelCreation', 'methodLabelManual'].includes(this.state.value) &&
            <Row type="flex" justify="center" align="top">
              <Col>
                <h4 style={{fontWeight: '500', fontSize: '16px', marginBottom: 'unset'}}>
                  {this.state.convenienceReturn?.title}
                </h4>
              </Col>
              <Divider />
            </Row>
          }
          {this.state.enableConvenience && ['methodLabelCreation', 'methodLabelManual'].includes(this.state.value) &&
            <Row type="flex" justify="center" align="top">
              <Col span={24}>
                <Select
                  value={this.state.returnPreference}
                  placeholder={
                    <FormattedMessage
                      id="app.visitor.method.Dropdown"
                      description="Return preference selection dialog: title of the dropdown menu"
                      defaultMessage="Select return preference"
                    />
                  }
                  style={{ width: '50%' }}
                  onChange={this.handleReturnReference.bind(this)}
                >
                  {this.state.convenienceReturn?.options.map(value => {
                    return (
                      <Option key={value} value= {value}>
                        {value}
                      </Option>
                    )
                  })}
                </Select>
              </Col>
              <Divider />
            </Row>
          }
          <Row type="flex" justify="center" align="top">
            <Col>
              {
                !this.state.isLoading && !this.state.freeReturn && (this.props.returnSettings.restockingFeeEnabled || (this.props.returnData && this.props.returnData.ruleActionCustomRestockingFee))
                  ? (
                    <Row type="flex" justify="center" align="top">
                      <Col>
                        <p>
                          <strong>{parseFloat(this.props.returnData.restockingFeeValue).toFixed(2)} {(this.props.returnData.restockingFeeType === "percentage" || this.props.returnData.restockingFeeType === "percentageTax") ? "%" : this.props.orderData.currency} </strong>
                          <FormattedMessage
                            id="app.visitor.resolutions.infoRestockingFee"
                            description="Shipping method selection dialog: info about restocking-fee (optional)"
                            defaultMessage="restocking-fee applies."
                          />
                        </p>
                      </Col>
                    </Row>
                  )
                  : ""
              }
              {
                !this.state.isLoading && !this.state.freeReturn && (this.state.value === "methodLabelCreation" || this.state.value === "methodLabelManual") && (this.state.enableConvenience || this.props.returnSettings.labelFeeEnabled || (this.props.returnData && this.props.returnData.ruleActionCustomLabelFee))
                  ? (
                    this.state.enableConvenience ?
                      (this.state.returnPreference === 'Regular' && (this.props.returnSettings.labelFeeEnabled || (this.props.returnData && this.props.returnData.ruleActionCustomLabelFee))) ?
                        <p>
                          <strong>{parseFloat(this.props.returnData.labelFeeValue).toFixed(2)} {this.props.orderData.currency} </strong>
                          <FormattedMessage
                            id="app.visitor.method.infoLabelFee"
                            description="Shipping method selection dialog: info about label-fee (optional)"
                            defaultMessage="label-fee applies for the prepaid shipping-label we provide you."
                          />
                        </p>
                        : this.state.returnPreference === 'Convenience' ?
                          <p>
                            <strong>{parseFloat(this.state.convenienceReturn?.convenienceLabelFee).toFixed(2)} {this.props.orderData.currency} </strong>
                            <FormattedMessage
                              id="app.visitor.method.infoLabelFee"
                              description="Shipping method selection dialog: info about label-fee (optional)"
                              defaultMessage="label-fee applies for the prepaid shipping-label we provide you."
                            />
                          </p>
                          : ""
                      :
                      <p>
                        <strong>{parseFloat(this.props.returnData.labelFeeValue).toFixed(2)} {this.props.orderData.currency} </strong>
                        <FormattedMessage
                          id="app.visitor.method.infoLabelFee"
                          description="Shipping method selection dialog: info about label-fee (optional)"
                          defaultMessage="label-fee applies for the prepaid shipping-label we provide you."
                        />
                      </p>
                  )
                  : ""
              }
              {
                /* RICH-1900. The merchant-entered description carries the meaning
                   here, so unlike the other two fees this row leads with it. */
                !this.state.isLoading && !this.state.freeReturn && this.props.returnData && this.props.returnData.ruleActionCustomFee
                  ? (
                    <Row type="flex" justify="center" align="top">
                      <Col>
                        <p style={{ overflowWrap: 'anywhere' }}>
                          <strong>{parseFloat(this.props.returnData.ruleCustomFeeAmount).toFixed(2)} {this.props.returnData.ruleCustomFeeType === "percentage" ? "%" : this.props.orderData.currency} </strong>
                          {this.props.returnData.ruleCustomFeeDescription
                            ? this.props.returnData.ruleCustomFeeDescription
                            : (
                              <FormattedMessage
                                id="app.visitor.method.infoCustomFee"
                                description="Shipping method selection dialog: info about a merchant-defined custom fee (optional)"
                                defaultMessage="custom fee applies."
                              />
                            )}
                        </p>
                      </Col>
                    </Row>
                  )
                  : ""
              }
              <p>
                <FormattedMessage
                  id="app.visitor.method.infoViaEmail"
                  description="Shipping method selection dialog: info to user that they receive instructions via email"
                  defaultMessage="We will send you the instructions via e-mail once your request has been approved."
                />
              </p>
            </Col>
          </Row>
          <Divider />
          <Row type="flex" justify="center" align="top">
            <Col>
              {/* {
                this.state.submitButtonLoading
                  ? <Button shape="circle" loading={this.state.submitButtonLoading} style={{ marginRight: 20 }}/>
                  : null
              } */}
              <Button
                type="primary"
                onClick={ this.handleSubmit }
                disabled={this.state.submitButtonDisabled}
                style={{ backgroundColor: this.props.brandColorButton, borderColor: this.props.brandColorButton, fontStyle: this.props.brandFontStyle }}
              >
                {
                  this.state.submitButtonLoading
                    ? (
                      <span style={{ color: this.props.brandColorButtonText, fontStyle: this.props.brandFontStyle }}>
                        <FormattedMessage
                          id="app.visitor.method.buttonSubmitLoading"
                          description="Shipping method selection dialog: submit button is loading..."
                          defaultMessage="Creating your return..."
                        />
                      </span>
                    )
                    : (
                      <span style={{ color: this.props.brandColorButtonText, fontStyle: this.props.brandFontStyle }}>
                        <FormattedMessage
                          id="app.visitor.method.buttonSubmit"
                          description="Shipping method selection dialog: submit button"
                          defaultMessage="Submit"
                        />
                      </span>
                    )
                }
              </Button>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

export default Method;
